import moment from 'moment';
import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { TherapistAction, addTaskConstant } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

const {
  ADD_TASK_THERAPIST_REQUEST,
  ADD_TASK_THERAPIST_SUCCESS,
  ADD_TASK_THERAPIST_FAILURE,
  ADD_TASK_THERAPIST_RESET,
  ADD_TASK_THERAPIST_LOADING,
} = addTaskConstant;

function* therapistAddTask(action: any): SagaReturnType<any> {
  try {
    yield put({ type: ADD_TASK_THERAPIST_LOADING });
    const response = yield call(therapistSchedulingServices.AddTask, action.payload);
    if (response?.status === 200) {
      yield put({ type: ADD_TASK_THERAPIST_SUCCESS, payload: response.data });

      yield put({
        type: TherapistAction.GET_ALL_THERAPIST_TASK_REQUEST,
        payload: {
          data: {
            providerId: action.payload.providerId,
            localDate: action.payload.data.localDate
              ? moment(action.payload.data.localDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : '',
            type: action.payload?.type || '',
            active: true,
            discipline: action.payload.data.discipline,
            skill: '',
            isV2: action.payload?.isV2,
          },
          pageNo: 0,
        },
      });
      yield put({
        type: TherapistAction.DISABLE_AUTO_MATCH_REQUEST,
        payload: {
          providerId: action.payload.providerId,
          discipline: action.payload.data.discipline,
          currentDate: action.payload.data.localDate
            ? moment(action.payload.data.localDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
            : '',
        },
      });
      yield put({
        type: TherapistAction.GET_ALL_THERAPIST_DICIPLINE_TYPE_REQUEST,
        payload: {
          providerId: action.payload.providerId,
          localDate: action.payload.data.localDate
            ? moment(action.payload.data.localDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
            : '',
          data: {
            isV2: action.payload?.isV2,
          },
        },
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: ADD_TASK_THERAPIST_FAILURE, payload: error });
  }
}

function* therapistAddTaskSaga() {
  yield takeEvery(ADD_TASK_THERAPIST_REQUEST, therapistAddTask);
}

export default therapistAddTaskSaga;
